import {connect} from 'react-redux'
import {ConfirmationBox} from './confirmation-box'
import {appDictionary} from "../../../app"


const mapStateToProps = (state) => ({
  dictionary: appDictionary(state),
})

export const ConfirmationBoxConnected = connect(mapStateToProps, null)(ConfirmationBox)